import PropTypes from 'prop-types'
import { useState } from 'react'
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from '@components/ui/command'
import { Popover, PopoverContent, PopoverTrigger } from '@components/ui/popover'
import { Button } from '@components/ui/button'
import { Label } from '@components/ui/label'
import { Check, ChevronsUpDown } from 'lucide-react'
import { cn } from 'lib/utils'

export const AdasAutoComplete = ({
  options = [],
  value,
  onChange,
  label,
  name = '',
  disabled,
  placeholder = 'Select...',
  className,
  // eslint-disable-next-line no-unused-vars
  sx,
  // eslint-disable-next-line no-unused-vars
  renderInput,
  // eslint-disable-next-line no-unused-vars
  renderOption,
  // eslint-disable-next-line no-unused-vars
  freeSolo,
  // eslint-disable-next-line no-unused-vars
  disableClearable,
  // eslint-disable-next-line no-unused-vars
  labelId,
  // eslint-disable-next-line no-unused-vars
  id,
  ...props
}) => {
  const [open, setOpen] = useState(false)

  const keyValuePairs = options.map((option) =>
    typeof option === 'object' ? { key: option.id, label: option.name || option.value } : { key: option, label: option }
  )

  const selectedOption = keyValuePairs.find((opt) => opt.key === value) || null
  const selectedLabel = selectedOption != null ? selectedOption.label : placeholder

  return (
    <div className={cn('flex flex-col gap-1', className)}>
      {label && <Label className='text-xs font-medium text-text-primary'>{label}</Label>}
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button
            variant='outline'
            role='combobox'
            aria-expanded={open}
            disabled={disabled}
            className={cn(
              'w-full h-11 px-3 justify-between font-normal rounded-lg text-[15px] border border-input bg-card',
              !selectedOption && 'text-muted-foreground'
            )}
          >
            <span className='truncate'>{selectedLabel}</span>
            <ChevronsUpDown className='ml-2 h-4 w-4 shrink-0 opacity-50' />
          </Button>
        </PopoverTrigger>
        <PopoverContent className='w-[var(--radix-popover-trigger-width)] p-0' align='start'>
          <Command>
            <CommandInput placeholder='Search...' />
            <CommandList>
              <CommandEmpty>No options found.</CommandEmpty>
              <CommandGroup>
                {keyValuePairs.map((option) => {
                  const isSelected = option.key === value
                  return (
                    <CommandItem
                      key={option.key}
                      value={option.label}
                      onSelect={() => {
                        if (onChange) {
                          onChange({
                            target: {
                              name,
                              value: option.key || ''
                            }
                          })
                        }
                        setOpen(false)
                      }}
                    >
                      <Check className={cn('mr-2 h-4 w-4', isSelected ? 'opacity-100' : 'opacity-0')} />
                      {option.label}
                    </CommandItem>
                  )
                })}
              </CommandGroup>
            </CommandList>
          </Command>
        </PopoverContent>
      </Popover>
    </div>
  )
}

AdasAutoComplete.propTypes = {
  options: PropTypes.array,
  value: PropTypes.any,
  onChange: PropTypes.func,
  label: PropTypes.string,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  className: PropTypes.string
}
